import React from "react";
import PropTypes from "prop-types";
import { ARCTIC } from "../../../constants/constants";

const RebnyFooter = ({ theme }) => {
  return (
    <div className="rebny-holder">
      <p className="main-disc">
        <img
          src={
            theme === ARCTIC
              ? "/img/rebny/rebny-color.png"
              : "/img/rebny/rebny-white.png"
          }
          alt="Renby Disclaimer Logo"
          width="145"
          height="40"></img>
        This information is not verified for authenticity or accuracy and is not
        guaranteed and may not reflect all real estate activity in the market.
        ©️ {new Date().getFullYear()} The Real Estate Board of New York, Inc.,
        All rights reserved.
      </p>
      <p className="sub-disc">
        RLS Data display by Sotheby’s International Realty, Inc.
      </p>
    </div>
  );
};

RebnyFooter.propTypes = {
  theme: PropTypes.string,
};

export default RebnyFooter;



// WEBPACK FOOTER //
// ./src/components/shared/footer/rebny-footer.js